import NoLaunch from '@/assets/imges/no-launch.png'
import styled from 'styled-components'
import { t } from '@/i18n'

export default function GeneralReport() {
  return (
    <Container>
      <div className="image-wrapper">
        <img src={NoLaunch} alt="no-launch" />
      </div>
      <div className="title-wrapper">
        <span>{t('暂未开通模块')}</span>
      </div>
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 16px;
  background: #fff;
  height: calc(100% - 32px);
  border-radius: 8px;
  box-shadow: 0px 4px 8px 0px rgba(95, 103, 129, 0.06);
  .image-wrapper {
    margin-top: -300px;
  }
  .title-wrapper {
    font-family: SourceHanSansCN, SourceHanSansCN;
    font-weight: 500;
    font-size: 16px;
    color: #666666;
    line-height: 24px;
    text-align: left;
    font-style: normal;
    margin-top: -50px;
  }
`
